import React, { useState, useEffect, useMemo } from "react"
import GridTypeA from "components/grids/GridTypeA/GridTypeA"

// Cell Renderers
import PRSUploadStatus from "../ag-grid-cell-renderers/PRSUploadStatus" // TODO: replace with src/components/ag-grid-cell-renderers/PrsUploadStatusCell/PrsUploadStatusCell?
import PRSRecordStatus from "../ag-grid-cell-renderers/PRSRecordStatus"
import PRSErrors from "../ag-grid-cell-renderers/PRSErrors/PRSErrors"
import DocumentsUploadStatus from "components/ag-grid-cell-renderers/DocumentsUploadStatus/DocumentsUploadStatus"

var rowHeight = 30

const PRSSummaryGrid = ({ data, hasErrors }) => {
  const [gridApi, setGridApi] = useState(null)
  const [rowData, setRowData] = useState([])

  const gridOptions = useMemo(() => {
    return {
      columnDefs: [
        {
          headerName: "Study ID",
          field: "study_id",
          width: 120,
        },
        {
          headerName: "PRS Upload Status",
          field: "prs_upload_status",
          cellRenderer: PRSUploadStatus,
          cellRendererParams: {
            parentData: data,
          },
          initialHide: true,
          width: 180,
        },
        {
          headerName: "PRS Record Status",
          field: "ctg_release_status",
          cellRenderer: PRSRecordStatus,
          width: 180,
          cellRendererParams: {
            parentData: data,
          },
          initialHide: true,
        },
        {
          headerName: "File(s) submitted",
          field: "uploaded_docs",
          cellRenderer: DocumentsUploadStatus,
          flex: 1,
          initialHide: true,
        },
        {
          headerName: "Errors",
          field: "errors",
          cellRenderer: PRSErrors,
          cellRendererParams: {
            parentData: data,
          },
          initialHide: true,
          flex: 1,
        },
      ],
      defaultColDef: {
        wrapText: true,
        cellStyle: { whiteSpace: "normal" },
      },
      components: {
        PRSUploadStatus,
        PRSRecordStatus,
        PRSErrors,
      },
    }
  }, [data])

  useEffect(() => {
    if (gridApi) {
      if (hasErrors) {
        gridApi.setColumnsVisible(["errors"], true)
      }
      if (data?.upload_records?.[0]) {
        let firstRecord = data.upload_records[0]
        if (firstRecord.document_upload_status) {
          gridApi.setColumnsVisible(["uploaded_docs"], true)
        }
        if (firstRecord?.upload_report?.uploadStatus || data?.is_cancelled) {
          gridApi.setColumnsVisible(["ctg_release_status"], true)
          gridApi.setColumnsVisible(["prs_upload_status"], true)
        }
      }

      gridApi.sizeColumnsToFit()
    }
  }, [gridApi, hasErrors, data])

  useEffect(() => {
    if (data) {
      setRowData(
        data.upload_records.map((record) => {
          let updatedRecord = { ...record }
          if (data.is_cancelled) {
            updatedRecord.is_cancelled = true
          }

          return {
            ...updatedRecord,
          }
        })
      )
    } else {
      setRowData([])
    }
  }, [data])

  const onGridReady = (params) => {
    setGridApi(params.api)
    params.api.sizeColumnsToFit()
  }

  const getRowHeight = (params) => {
    if (rowHeight !== null) {
      return rowHeight
    }
  }

  return (
    <GridTypeA
      onGridReady={onGridReady}
      getRowHeight={getRowHeight}
      gridOptions={gridOptions}
      rowData={rowData}
      domLayout="autoHeight"
    />
  )
}

export default PRSSummaryGrid
